import {FormFieldType} from '../enums/form-field-type.enum';

export function fieldTypeHasDefault(value: string): boolean {
  const fieldType = value as FormFieldType;
  return fieldType !== FormFieldType.SELECT &&
    fieldType !== FormFieldType.RADIO &&
    fieldType !== FormFieldType.DATE &&
    fieldType !== FormFieldType.HIDDEN;
}
